import { render, staticRenderFns } from "./CpE_LowStockReminder_List.vue?vue&type=template&id=7ce78eb8"
import script from "./CpE_LowStockReminder_List.vue?vue&type=script&lang=js"
export * from "./CpE_LowStockReminder_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports